export default "__VITE_ASSET__DKRBVAnr__"